import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { PrideStepLoading } from '@/pages/Onboarding/components/PrideStepLoading';
import { useOnboarding } from '@/pages/Onboarding/context.tsx';
import { canLogEvents } from '@/utils/canLogEvents.ts';

import { PageStyles, PageTitleStyles } from './WelcomeScreen.styles.ts';

export const WelcomeScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Welcome Screen G12',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="none">
      <IonContent>
        <div className="content-wrapper">
          <LogoWithAppName className="app-logo" withCaption={false} />

          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="headline-large"
            align="center"
          >
            Create your Own
            <br />
            <PageTitleStyles
              variant="inherit"
              color="white"
              component="span"
              className="page-subtitle"
            >
              AI Boyfriend
            </PageTitleStyles>
          </PageTitleStyles>

          <div className="loading-wrapper">
            <PrideStepLoading
              duration={3.5}
              onComplete={() => handleNextStep()}
            />
          </div>
        </div>
      </IonContent>
    </PageStyles>
  );
};
